export default __webpack_public_path__ + "static/media/11.dd09d0f9.jpg";